// extracted by mini-css-extract-plugin
module.exports = {"container":"DropdownMenu_container__3ki2k"};